
import { defineComponent } from '@vue/runtime-core'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'
export default defineComponent({
  props: {
    gutter: Number,
    span: Number,
    courses: Object,
    withoutIntroduce: {
      type: Boolean,
      default: true
    },
    isSubject: {
      type: Boolean,
      default: false
    }
  },
  setup(porps: any, context: any) {
    const route = useRoute()
    function jumpToCourse(courseNo: number, lessonNo: number) {
      if (!route.query.token) {
        gotoClientLogin()
        return
      }
      context.emit('jumpToCourse', { courseNo, lessonNo })
    }
    function gotoSpecialCourse(item: any) {
      context.emit('gotoSpecialCourse', item)
    }

    return {
      jumpToCourse,
      gotoSpecialCourse
    }
  }
})
